<template>
	<div class="header m-header v-between" :class="{ 'navRightright': collapsed, 'register': register }" >
		<div class="headerL" @click.prevent="collapse" v-if="!register">
			<transition enter-active-class="animated rotateIn" out-active-class="animated rotateOut">
				<img src='../assets/img/icon/pick_up.png' class="nav_pick up" v-show="collapsed" />
			</transition>
			<transition enter-active-class="animated rotateIn" out-active-class="animated rotateOut">
				<img src='../assets/img/icon/pick.png' class="nav_pick" v-show="!collapsed" />
			</transition>
		</div>
		<div class="headerL" v-else>
			<img src='../assets/img/logo1.png' class='logo1' />
		</div>
		<div class="headerR fr" style="display:inline-flex">
			<!--切换城市-->
			<div style="position: relative;" v-if="!register">
				<el-popover popper-class='cityPopper' ref="popover4" placement="bottom" width="100%" :class="collapsed ? 'large':'small'" trigger="click" @show="showHandle" v-model="visible" @hide='hidetion'>
					<choose-park  @changeProject="changeProject" @refrashStatus="refrashStatus"/>
					<div class="msgbox" @click="withdrawtion" style="height: 100%;"></div>
				</el-popover>
				
			</div>
			<div class="borderBox navHover changeCity" v-popover:popover4 v-if="!register">
				<span class="oneLine fr">{{ projectName }}</span>
				<span class="switch">[项目切换]</span>
			</div>
			<!-- 公司名称 -->
			<div class="userName">
				<i class="iconfont icon-top_park"></i>
				<span class="companyName ellipsis-basic">{{companyName || ''}}</span>
				<template v-if="checkStatus">
					<el-tag class='tags' v-if="checkStatus != '审核通过'" :type="checkStatus == '审核驳回' ? 'danger' : 'warning'">{{ checkStatus || '' }}</el-tag>
				</template>
			</div>
			<!-- 消息 -->
			<div class="msgList" @click="showMail">
				<i class="iconfont icon-top_messege"></i>
				<span>消息</span>
			</div>
			<!-- 退出登录 -->
			<div class="logout" @click="logout">
				<i class="iconfont icon-top_back"></i>
				<span>退出</span>
			</div>
		</div>
	</div>
  	
</template>

<script>
import API from '@/fetch/api'
import * as access from '@/config/access';
import choosePark from '@/components/choosePark';
import {  SetInfo } from '@/fetch/com'

export default {
	name: 'vheader',
	// register 代表注册界面
	props: ['collapsed', 'register'],
	data(){
		return {
			companyName: access.session('companyName') || '',
			projectName: access.session('projectName') || '',
			checkStatus: access.session('checkStatusC') || '',
			visible: false,
			parkId: access.session('projectId') || ''
		}
	},
	components: {
		choosePark
	},
	mounted(){
		// this.queryUserInfo();
	},
	methods: {
		refrashStatus(){
			this.checkStatus = access.session('checkStatusC') || '';
			this.projectName = access.session('projectName') || '';
			this.companyName = access.session('companyName') || '';
			this.parkId = access.session('projectId') || '';
		},
		hidetion(){
			this.$emit('hide');
		},
		showHandle(){
			this.$emit('show');
		},
		collapse(){
			this.$emit('collapse');
		},
		showMail(){
			this.$emit('showMail');
		},
		// 退出登录
        logout() {
            var vm = this;
            vm.$confirm('确定退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'btnNew btnSize',
                cancelButtonClass: 'btnSize',
            }).then(() => {
				access.session('token','');
				access.storage("projectId", ''); 
            	access.storage("projectName", ''); 
            	access.storage("checkStatus", ''); 
            	access.storage("companyName", ''); 
            	access.storage("newFlag", ''); 
            	access.storage("city", ''); 
                vm.$root.hashMenus = {};
                vm.$router.replace({name: 'login'});
            })    
		},
		withdrawtion() {
            this.visible = false;
		},
		changeProject(project){
			let vm = this;
			// vm.parkId = access.session('projectId') || '';
			if(project.id == vm.parkId) return;
			vm.projectName = project.projectName;
            access.storage("projectId", project.id); 
            access.storage("projectName", project.projectName); 
            access.storage("projectCode", project.projectCode);
            access.storage("leaseOrSale", project.leaseOrSale);
            access.storage("city", project.city);
			vm.parkId = project.id;
            vm.setCookie(project); 
            vm.$notify({
				title: '成功!',
				message: "项目切换成功",
				type: 'success',
				duration: 3000
			});
			vm.visible = false;
			vm.$router.push({ path: '/', params: { t: new Date().getSeconds() } });
			vm.$router.go(0);
		},
		setCookie(project) {
            SetInfo("projectId", project.id); //存储项目id
            SetInfo("projectName", project.projectName); //存储项目名称
            SetInfo("projectCode", project.projectCode); //存项目编码
            SetInfo("city", project.city); //存项目城市
        },
	}
}

</script>
<style  lang="scss" scoped>
@import '../style/variable';
	.m-header {
		padding-left: 230px;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		// padding-right: 70px;
		min-width: 1100px;
		z-index: 98;
		background: $c1;
		height: 70px;
		padding-left: 240px;
		-webkit-box-shadow: 0 2px 10px 4px rgba(8, 54, 80, 0.06);
		box-shadow: 0 2px 10px 4px rgba(8, 54, 80, 0.06);
		transition: all .3s;
		display: flex;
		justify-content: space-between;
		&.navRightright {
			padding-left: 70px;
		}
		&.register{
			padding-left: 30px;
			padding-right: 0;
		}
		.headerL {
			width: auto;
			margin-right: 25px;
			line-height: 70px;
			.logo1{
				width: 153px;
				height: auto;
				margin-top: 19px;
			}
			.nav_pick {
				cursor: pointer;
				width: 17px;
				height: 12px;
				margin-top: 27px;
				&.up {
					margin-top: 29px;
				}
			}
		}
		.headerR {
			// width: 380px;
			padding-right: 10px;
			// flex: 1;
			.changeCity {
				line-height: 70px;
				font-size: $fs_14;
				text-align: center;
				cursor: pointer;
				color: $c7;
				position: relative;
				display: inline-block;
				padding: 0 14px;
				.oneLine {
					padding-right: 6px;
				}
				.switch {
					color: $c4;
				}
			}
			
			.logout, .userName, .msgList{
				font-size: 14px;
				line-height: 70px;
				color: $c7;
				padding: 0 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				.companyName{
					display: inline-block;
					max-width: 160px;
				}
				// margin-left: 40px;
				.tags{
					margin-left: 5px;
					border-radius: 10px;
					font-size: $fs_12;
					&.el-tag--warning{
						background-color: $c10;
						border-color: $c10;
						color: $c1;
					}
				}
				
				i{
					color: $c4;
					font-size: $fs_14;
					margin-right: 6px;
				}
			}
			.logout:hover, .msgList:hover{
				background-color: $c8;
				cursor: pointer;
			}
		}
		.headerC {
			margin-left: 46px;
			position: relative;
			color: #676a6c;
			ul {
				li {
					float: left;
					width: 50px;
					text-align: center;
					line-height: 70px;
					cursor: pointer;
					padding: 0 5px;
					height: 70px;
				}
				li:hover {
					background-color: #f3f3f4;
				}
				li.checked {
					color: $c4;
					font-size: 20px;
					font-weight: bold;
					position: relative;
					&:after {
						content: '';
						display: block;
						transition: all .5s;
						width: 20px;
						margin: 0 auto;
						position: absolute;
						height: 3px;
						background: $c4;
						border-radius: 1.5px;
						bottom: 0;
						left: 20px;
					}
				}
			}
			.allMenu {
				box-sizing: border-box;
				position: absolute;
				top: 70px;
				left: -28px;
				padding: 30px 0px 0px 30px;
				background: rgba(28, 45, 59, 1);
				box-shadow: 0px 0px 10px 0px rgba(35, 51, 64, 0.5);
				border-radius: 4px;
				// transition: all .5s;
				&.close {
					height: 0;
					padding: 0 30px;
					overflow: hidden;
				}
				.el-button {
					margin-right: 20px;
					margin-bottom: 20px;
					margin-left: 0px;
					border-radius: 4px;
					border: 1px solid #537088;
					background: rgba(28, 45, 59, 0.95);
					&:hover {
						border-color: #45C3CC;
						color: #45C3CC;
					}
					&:active,
					&:focus {
						background: #45C3CC;
						color: $c1;
					}
				}
			}
			.moreMenu {
				position: absolute;
				right: 8px;
				top: 0px;
				width: 120px;
				height: 70px;
				background: linear-gradient(90deg, rgba(118, 131, 142, 0) 0%, rgba(21, 33, 43, 1) 50%);
				i {
					position: relative;
					right: -85px;
					top: 23px;
					display: block;
					width: 22px;
					height: 22px;
					cursor: pointer;
				}
			}
			.moreMenuIcon {
				background: url('../assets/img/icon/more.png') no-repeat;
				&:hover {
					background: url('../assets/img/icon/morehover.png') no-repeat;
				}
			}
			
			ul {
				max-width: 725px;
				max-height: 70px;
				overflow: hidden;
				li {
					width: auto;
					min-width: 64px;
					&:not(:last-child) {
						margin-right: 46px;
					}
					&:hover {
						background-color: rgba(21, 33, 43, 1);
						color: #45C3CC;
					}
					&.checked {
						width: auto;
						min-width: 64px;
						color: #45C3CC;
						font-size: 16px;
						&:after {
							width: 30px;
							background: #45C3CC;
						}
					}
				}
			}
		}
	}
</style>
